module.exports = __webpack_public_path__ + "img/budget.7066bec3.svg";